import { render, staticRenderFns } from "./ddLogin.vue?vue&type=template&id=131cca40&scoped=true"
import script from "./ddLogin.vue?vue&type=script&lang=js"
export * from "./ddLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131cca40",
  null
  
)

export default component.exports